import { Tracker } from 'react-tracker';
import { isEProcurementApp, getDefaultPathVar, getLocalCountryLanguage } from '../../utils';

const trackerConfig = {};

export const executeListners = () => {
  const { instance, callback, initialConfigs } = trackerConfig;
  if (!initialConfigs || !callback) {
    throw new ReferenceError(
      'Tracker Config missing. Use setTrackerConfig() to set tracker config on application bootstrap'
    );
  }
  instance.on('*', (event, eventsHistory) => {
    const { type, data } = event;
    const { localeLanguage: language, localeCountry: country } = isEProcurementApp()
      ? getDefaultPathVar()
      : getLocalCountryLanguage();
    const pageConfig = {
      ...initialConfigs.page,
      page_url: window.location.href,
      language,
      country,
    };
    callback({
      initialConfigs: { ...initialConfigs, page: pageConfig },
      data: { ...data },
      type,
      eventsHistory,
    });
    return event;
  });
};

export const setTrackerConfig = ({ initialConfigs, actions, callback }) => {
  trackerConfig.initialConfigs = initialConfigs;
  trackerConfig.actions = actions;
  trackerConfig.callback = callback;
  executeListners();
};

export const getTracker = () => {
  if (!trackerConfig.instance) {
    trackerConfig.instance = new Tracker();
  }
  return trackerConfig;
};
